<div class="row">
  <div class="col-md-6">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">User {{Title}}</h4>
        <div class="form-group">
          <label for="UserAccount">User Account *</label>
          <input type="text" class="required form-control" #UserAccount="ngModel" id="UserAccount" placeholder="" required
            [(ngModel)]="Doc.UserAccount" />

          <div [hidden]="UserAccount.valid || UserAccount.pristine" class="alert alert-danger">
            User Account is required
          </div>
        </div>
        <div class="form-group">
          <label for="UserName">User Name *</label>
          <input type="text" class="required form-control" #UserName="ngModel" id="UserName" placeholder="" required
            [(ngModel)]="Doc.UserName" />
          <div [hidden]="UserName.valid || UserName.pristine" class="alert alert-danger">
            User Name is required
          </div>
        </div>
        <div class="form-group">
          <label for="EMail">Email *</label>
          <div class="input-group">
            <input type="email" class="form-control" id="EMail" [(ngModel)]="Doc.EMail"
              #EMail="ngModel" aria-label="EMail" placeholder=""/>
            <div [hidden]="EMail.valid || EMail.pristine" class="alert alert-danger">
              Email is required
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="UserType">User Type</label>
          <ng-select [searchable]="false" [items]="Doc.ddlUserType" id="UserType" bindValue="value" bindLabel="text"
            [clearable]="false" [(ngModel)]="Doc.UserType">
          </ng-select>
        </div>
        <div class="form-group">
          <label for="Enabled">IsEnabled</label>
          <ng-select [searchable]="false" [items]="Doc.ddlIsEnabled" id="IsEnabled" bindValue="value" bindLabel="text"
            [clearable]="false" [(ngModel)]="Doc.SelectEnabled">
          </ng-select>
        </div>
        <p>(*) Mandatory</p>
      </div>
      <div class="border-top">
        <div class="card-body">
          <button (click)="Cancel()" class="btn btn-outline-secondary" role="button">Cancel</button>
          <button (click)="Submit()" class="btn btn-success ml-1" role="button" [disabled]="isValid()">Submit</button>
        </div>
      </div>
    </div>
  </div>
</div>